import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import ModalTestUser from './parts/ModalTestUser/ModalTestUser';

import { declOfNum } from 'utils/common';

import { userState } from 'contexts/actions/authActions';

import classes from './StatusTestUser.module.scss';

const StatusTestUser = ({ dayToFinish = 0, errorCode, mixpanel }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;

  const [modalTestUser, setModalTestUser] = useState(false);
  const dispatch = useUserStateDispatch();

  useEffect(() => {
    if (errorCode === 400) {
      setModalTestUser(true);
      userState({
        error: undefined
      })(dispatch);
    }
    // eslint-disable-next-line
  }, [errorCode]);

  return (
    <div className={classes.statusTestUser}>
      <ModalTestUser
        isOpen={modalTestUser}
        setIsOpen={() => {
          trackingEvent('close_trial_modal', mixpanel, username);
          setModalTestUser(false);
        }}
        mixpanel={mixpanel}
      />
      <div className={classes.statusHeader}>
        <p className={classes.text}>
          {t('statusTestUser', 'TEST_END', language)}
          <span className={classes.checkitText}>CheckIt</span>{' '}
          {t('statusTestUser', 'TEST_LEFT', language)}
          <span className={classes.number}>{dayToFinish}</span>
          <span className={classes.days}>
            {t(
              'statusTestUser',
              declOfNum(dayToFinish, ['DAYv1', 'DAYv2', 'DAYv3']),
              language
            )}
          </span>
        </p>
        <button
          type="button"
          className={classes.getStatusBtn}
          onClick={() => {
            trackingEvent('open_trial_modal', mixpanel, username);
            setModalTestUser(true);
          }}
        >
          {t('statusTestUser', 'GET_ACCESS', language)}
        </button>
      </div>
    </div>
  );
};

StatusTestUser.propTypes = {
  mixpanel: PropTypes.object,
  dayToFinish: PropTypes.number,
  errorCode: PropTypes.number
};

export default StatusTestUser;
